import { isString } from 'lodash';
import { Quill } from 'react-quill';

const ATTRIBUTES = ['height', 'width', 'class', 'style'];
const Image = Quill.import('formats/image');

class ImageFormatter extends Image {
  static create(props) {
    const node = super.create();

    if (isString(props)) {
      node.setAttribute('src', props);
    } else {
      node.setAttribute('src', props.src);
      ATTRIBUTES.forEach((attr) => {

        props[attr] && node.setAttribute(attr, props[attr]);
      });
    }

    return node;
  }

  static formats(domNode) {
    return ATTRIBUTES.reduce((formats, attribute) => {
      const copy = { ...formats };

      if (domNode.hasAttribute(attribute)) {
        copy[attribute] = domNode.getAttribute(attribute);
      }

      return copy;
    }, {});
  }

  static value(node) {
    return ATTRIBUTES.reduce(
      (attrs, attribute) => {
        const copy = { ...attrs };

        if (node.hasAttribute(attribute)) {
          copy[attribute] = node.getAttribute(attribute);
        }

        return copy;
      },
      { src: node.getAttribute('src') },
    );
  }

  format(name, value) {
    if (ATTRIBUTES.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}

export default ImageFormatter;
